import { useState, useEffect, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { supabase } from '../../supabase/config';
import { Button } from '../../components/admin/shared/Button';
import { useToast, ToastContainer } from '../../components/admin/shared/Toast';
import { Plus, User, } from 'lucide-react';

const Dashboard = () => {
  const [stats, setStats] = useState({
    projects: 0,
    skills: 0,
    experience: 0,
    testimonials: 0
  });
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  const { toasts, addToast } = useToast();

  const fetchStats = useCallback(async () => {
    try {
      const [projectsRes, skillsRes, experienceRes, testimonialsRes] = await Promise.all([
        supabase.from('projects').select('*', { count: 'exact', head: true }),
        supabase.from('skills').select('*', { count: 'exact', head: true }),
        supabase.from('experience').select('*', { count: 'exact', head: true }),
        supabase.from('testimonials').select('*', { count: 'exact', head: true })
      ]);

      setStats({
        projects: projectsRes.count || 0,
        skills: skillsRes.count || 0,
        experience: experienceRes.count || 0,
        testimonials: testimonialsRes.count || 0
      });
    } catch (error) {
      console.error('Error fetching stats:', error);
      addToast('Error loading statistics', 'error');
    } finally {
      setLoading(false);
    }
  }, [addToast]);

  useEffect(() => {
    fetchStats();
  }, [fetchStats]);

  return (
    <div>
      <ToastContainer toasts={toasts} />
      
      <h1 className="text-3xl font-bold text-white mb-8">Dashboard</h1>

      {/* Stats Cards */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 mb-8">
        <div className="bg-slate-800 rounded-lg p-6 border border-slate-700">
          <div className="text-slate-400 text-sm mb-2">📊 Projects</div>
          <div className="text-3xl font-bold text-white">
            {loading ? '...' : stats.projects}
          </div>
        </div>
        <div className="bg-slate-800 rounded-lg p-6 border border-slate-700">
          <div className="text-slate-400 text-sm mb-2">🛠️ Skills</div>
          <div className="text-3xl font-bold text-white">
            {loading ? '...' : stats.skills}
          </div>
        </div>
        <div className="bg-slate-800 rounded-lg p-6 border border-slate-700">
          <div className="text-slate-400 text-sm mb-2">📝 Experience</div>
          <div className="text-3xl font-bold text-white">
            {loading ? '...' : stats.experience}
          </div>
        </div>
        <div className="bg-slate-800 rounded-lg p-6 border border-slate-700">
          <div className="text-slate-400 text-sm mb-2">💬 Testimonials</div>
          <div className="text-3xl font-bold text-white">
            {loading ? '...' : stats.testimonials}
          </div>
        </div>
      </div>

      {/* Quick Actions */}
      <div className="bg-slate-800 rounded-lg p-6 border border-slate-700">
        <h2 className="text-xl font-bold text-white mb-4">Quick Actions</h2>
        <div className="flex flex-wrap gap-4">
          <Button
            variant="primary"
            onClick={() => navigate('/admin/projects')}
            className="flex items-center gap-2"
          >
            <Plus size={18} />
            Add New Project
          </Button>
          <Button
            variant="secondary"
            onClick={() => navigate('/admin/skills')}
            className="flex items-center gap-2"
          >
            <Plus size={18} />
            Add Skill
          </Button>
          <Button
            variant="secondary"
            onClick={() => navigate('/admin/profile')}
            className="flex items-center gap-2"
          >
            <User size={18} />
            Edit Profile
          </Button>
        </div>
      </div>
    </div>
  );
};

export default Dashboard;

